export default __webpack_public_path__ + "static/media/648b8fa9b8d5c2ebca1ee2ca7e6646a91581616758160.3c8ff8fd.webp";